<template>
    <div id="amazon-root" v-on:click='clicked'>
      <div class=" col-xs-8 col-xs-offset-2 csp-no-pad"><slot></slot></div>
      <div class="col-xs-2 csp-no-pad" v-if="amazonSigninLoading">
        <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
</template>

<script>
export default {
  name: 'amz-signin-button',
  props: {
    params: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  computed: {
    amazonSigninLoading: {
      get: function () {
        return this.$store.getters.amazonSigninLoading
      },
      set: function (newValue) {
        this.$store.commit('setAmazonSigninLoading', newValue)
      }
    }
  },
  methods: {
    clicked: function () {
      this.amazonSigninLoading = true // set the trigger for the loading icon
      const options = {
        scope: this.params.scope
      }

      const authRequest = window.amazon.Login.authorize(options, (response) => {
        if (response.error) {
          this.$emit('failure', response)
          this.$emit('error', response)
        } else {
          this.$emit('success', response)
        }
      })

      setTimeout(() => {
        console.log('Did not complete Amazon login within the expected timeframe: %j', authRequest)
        this.amazonSigninLoading = false
      }, this.$store.getters.signinTimeout)
    }
  },
  mounted: function () {
    const amzClientId = this.params.clientId

    window.onAmazonLoginReady = function () {
      if (!window.amazon) {
        console.err('Amazon SDK not present.')
        return
      }

      if (!amzClientId) {
        console.err('params.clientId must be specified.')
        return
      }

      window.amazon.Login.setClientId(amzClientId)
    };

    /**
     * Include Amazon SDK
     */
    (function (d) {
      var a = d.createElement('script')
      a.type = 'text/javascript'
      a.async = true
      a.id = 'amazon-login-sdk'
      a.src = 'https://api-cdn.amazon.com/sdk/login1.js'
      d.getElementById('amazon-root').appendChild(a)
    })(document)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Amazon.vue?67480622